import { render, staticRenderFns } from "./upload-file.vue?vue&type=template&id=dd841024&scoped=true&"
import script from "./upload-file.vue?vue&type=script&lang=js&"
export * from "./upload-file.vue?vue&type=script&lang=js&"
import style0 from "./upload-file.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./upload-file.vue?vue&type=style&index=1&id=dd841024&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd841024",
  null
  
)

export default component.exports